import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '../../../shared/module/material.module';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { PayrollRedelegationsDetails } from '../../../interface/temporaryredelegation/approveredelegation';
import { TemporaryRedelegationService } from '../../../services/temporaryredelegation/temporary-redelegation.service';
import { MatPaginator } from '@angular/material/paginator';
import { CalAngularService } from '@cvx/cal-angular';
import { SharedServices } from '../../../shared/services/shared.services';
import { ConfirmdialogComponent } from '../../../shared/component/confirmdialog/confirmdialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-payrolldownload',
  standalone: true,
  imports: [CommonModule, FormsModule, MaterialModule, MatTableModule],
  templateUrl: './payrolldownload.component.html',
  styleUrls: ['./payrolldownload.component.css']
})
export class PayrolldownloadComponent implements OnInit, AfterViewInit {
  sDateField: string = 'endDate';
  dStartDate!: string;
  dEndDate!: string;
  payMonth?: string;
  selectedMonth!: string;
  year!: number;
  redelegations: PayrollRedelegationsDetails[] = [];
  holidays: any[] = [];
  years: number[] = [];
  currentYear: number = new Date().getFullYear();
  loggedUserEmail: string = '';
  public paginator!: MatPaginator;
  dataSource = new MatTableDataSource<PayrollRedelegationsDetails>();
  error: string | null = null;
  isLoading: boolean = false;
  displayedColumns: string[] = [
    'sNo', 'enteredDate', 'toEmpno', 'toName', 'fromJobtitle', 'fromEmpno', 'fromName', 'dueTo', 'jobLocation', 'startDate', 'endDate', 'nDays'
  ];
  months: { name: string, value: string }[] = [
    { name: 'January', value: '01' },
    { name: 'February', value: '02' },
    { name: 'March', value: '03' },
    { name: 'April', value: '04' },
    { name: 'May', value: '05' },
    { name: 'June', value: '06' },
    { name: 'July', value: '07' },
    { name: 'August', value: '08' },
    { name: 'September', value: '09' },
    { name: 'October', value: '10' },
    { name: 'November', value: '11' },
    { name: 'December', value: '12' }
  ];

  constructor(private payrolldownloadService: TemporaryRedelegationService, private authService: CalAngularService, private sharedService: SharedServices, public dialog: MatDialog) {}
  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  ngOnInit(): void {
    this.initializeYears();
    this.setDefaultMonth();
    this.setDefaultStartDate(); 
    this.setDefaultEndDate();
    this.loggedUserEmail = this.authService.cvxClaimsPrincipal.userName ?? '';
  }
  ngAfterViewInit(): void {
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    if (this.paginator) {
      this.dataSource.paginator = this.paginator;
    }
  }

  initializeYears(): void {
    this.years = Array.from({ length: 10 }, (_, i) => this.currentYear - i);
  }
  setDefaultMonth(): void {
    const currentMonth = new Date().getMonth() + 1; // getMonth() returns 0-11, so add 1 for 1-12
    this.selectedMonth = currentMonth < 10 ? '0' + currentMonth : currentMonth.toString();
    this.year = this.currentYear;
  }

  searchRedelegations(): void {
    if (this.dStartDate && this.dEndDate) {
      this.isLoading = true;
      this.payrolldownloadService.getApprovedRedelegations(this.dStartDate, this.dEndDate).subscribe(
        (data) => {
          this.isLoading = false;
          this.redelegations = data;
          this.dataSource.data = data; 
          if (data && data.length > 0) {
            this.error = null;
          } else {
            this.error = 'No matching records found!';
            this.dataSource.data = [];
          }
        },
        (error) => {
          this.isLoading = false;
          this.error = 'No matching records found!';
          this.dataSource.data = [];
        }
      );
    } else {
      if (!this.dStartDate) {
        this.sharedService.openModal('Message', 'Please select StartDate');
      }
      if (!this.dEndDate) {
        this.sharedService.openModal('Message', 'Please select EndDate');
      }
    }
  }

  downloadExcel(): void {
    if (this.dStartDate && this.dEndDate) {
      this.payrolldownloadService.GenerateRedelegationsExcelReport(this.dStartDate, this.dEndDate).subscribe((blob: Blob) => {
        const a = document.createElement('a');
        const objectUrl = URL.createObjectURL(blob);
        a.href = objectUrl;
        a.download = 'redelegations.xlsx';
        a.click();
        URL.revokeObjectURL(objectUrl);
      }, (error: any) => {
        console.error('Error downloading Excel file', error);
      });
    } else {
      console.error('Start Date and End Date are required for downloading Excel');
    }
  }

  processPayment(): void {
    const sLogonEmail = this.loggedUserEmail; 
    const enteredDate = new Date().toISOString();
    if (this.selectedMonth && this.loggedUserEmail && this.dStartDate && this.dEndDate && new Date().toISOString()) {
      this.payrolldownloadService.processPayment(this.selectedMonth, this.loggedUserEmail, this.dStartDate, this.dEndDate, new Date().toISOString()).subscribe(response => {
        this.sharedService.openModal('Success', 'Payment processed successfully');
        this.resetForm(); 
      }, error => {
        console.error('Error processing payment', error);
      });
    } else {
      console.error('Pay Month, Start Date, and End Date are required for processing payment');
    }
  }

  openConfirmationDialog(): void {
    const dialogRef = this.dialog.open(ConfirmdialogComponent, {
      
      data: { message: 'Are you sure you want to process the payment?' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.processPayment();
      } else {
        console.log('Payment process cancelled');
      }
    });
  }

  resetForm(): void {
    this.sDateField = '';
    this.dStartDate = '';
    this.dEndDate = '';
    this.setDefaultMonth();;
    this.year = this.currentYear;
    this.redelegations = [];
    this.dataSource.data = [];
  }

  
  setDefaultStartDate(): void {
    const today = new Date();
    const previousMonth = new Date(today.getFullYear(), today.getMonth() - 1, 15);
    this.dStartDate = this.formatDateToInputValue(previousMonth);
  }
  
  setDefaultEndDate(): void {
    const today = new Date();
    const currentMonth = new Date(today.getFullYear(), today.getMonth(), 14);
    this.dEndDate = this.formatDateToInputValue(currentMonth);
  }
  
  private formatDateToInputValue(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  
  
}
